/* eslint-disable import/no-extraneous-dependencies */
import { z } from 'zod';

export const SchemaEnvironment = z
  .object({
    NODE_ENV: z.string(),
    PUBLIC_URL: z.string(),
    REACT_APP_BASE_URL: z.string(),
    REACT_APP_HOST: z.string(),
    REACT_APP_NAME: z.string(),
    REACT_APP_WEB_PROTOCOL: z.string(),
    REACT_APP_VERSION: z.string(),
    REACT_APP_BUCKET_BASEURL: z.string(),
    REACT_APP_APOLLO_URI: z.string(),
    REACT_APP_API_URI: z.string(),
    REACT_APP_NAMESPACE: z.string(),
  })
  .strict();
